import { useLenis } from "lenis/react";
import { Link } from "react-router-dom";
import { Sparkle } from "lucide-react";
import { SOCIALS } from "@/constants/site";

const LINKS = [
  { label: "About", target: "#about", testId: "nav-link-about" },
  { label: "Sessions", page: "/sessions", testId: "nav-link-sessions" },
  { label: "Watch", url: SOCIALS.youtube, testId: "nav-link-watch" },
  { label: "The Deck", target: "#deck", testId: "nav-link-deck" },
  { label: "Contact", target: "#contact", testId: "nav-link-contact" },
];

const linkCls =
  "text-[11px] font-semibold uppercase tracking-[0.18em] text-[#DCD8D3] transition-colors duration-300 hover:text-[#D49A36] md:text-xs";

export default function Nav() {
  const lenis = useLenis();
  const go = (target) => (e) => {
    e.preventDefault();
    lenis?.scrollTo(target, { offset: -20, duration: 1.4 });
  };

  const renderLink = (link) => {
    if (link.page) {
      return (
        <Link key={link.testId} to={link.page} data-testid={link.testId} className={linkCls}>
          {link.label}
        </Link>
      );
    }
    if (link.url) {
      return (
        <a key={link.testId} href={link.url} data-testid={link.testId} target="_blank" rel="noopener noreferrer" className={linkCls}>
          {link.label}
        </a>
      );
    }
    return (
      <a key={link.testId} href={link.target} data-testid={link.testId} onClick={go(link.target)} className={linkCls}>
        {link.label}
      </a>
    );
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#D49A36]/10 bg-[#131110]/70 backdrop-blur-md">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={go("#top")}
          className="flex items-center gap-2 font-display text-xl italic text-[#F2EFE9] transition-colors duration-300 hover:text-[#D49A36]"
        >
          <Sparkle className="h-4 w-4 text-[#D49A36]" strokeWidth={1.5} />
          Umi Speaks
        </a>
        <div className="flex items-center gap-4 md:gap-9">{LINKS.map(renderLink)}</div>
      </nav>
    </header>
  );
}
